// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6GC0p","title":"styles_title__3X4pV"};